var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"count-button",class:{ active: _vm.active },attrs:{"type":"button"}},_vm.$listeners),[_vm._v(" +"+_vm._s(_vm.count)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }